import { createSelector } from 'reselect';
import { selectIsAuctionEnabled } from './selectIsAuctionEnabled';
import { EServiceId } from '../../types/reducers/publishTerms';
import { selectActiveServiceId } from '../../reducers/v2/promotion/selectors';

export const selectIsAuctionSelected = createSelector(
  [selectIsAuctionEnabled, selectActiveServiceId],
  (isAuctionEnabled, activeServiceId): boolean => {
    const isAuctionForServiceEnabled = activeServiceId === EServiceId.top;

    return isAuctionEnabled && isAuctionForServiceEnabled;
  },
);
